import { Avatar as ChakraAvatar, AvatarProps } from "@chakra-ui/core";
import React from "react";

const Avatar: React.FC<AvatarProps> = ({ src, ...props }) => {
  return <ChakraAvatar src={src?.replace("http://", "https://")} {...props} />;
};

export default Avatar;
